import { cn } from '@/lib/utils';

interface LoadingProps {
  label?: string;
  className?: string;
}

export const Loading = ({ label, className }: LoadingProps) => {
  return (
    <div
      className={cn(`flex items-center justify-center min-h-[50vh]`, className)}
    >
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">{label || ''}</p>
      </div>
    </div>
  );
};
